export const keyCodes: Record<string, string> = {
  keyEnter: 'Enter',
  keyTab: 'Tab',
  keyEsc: 'Escape',
  keySpace: 'Space',
  keyUp: 'ArrowUp',
  keyDown: 'ArrowDown',
  keyLeft: 'ArrowLeft',
  keyRight: 'ArrowRight',
  keyBackspace: 'Backspace',
  keyDelete: 'Delete',
  keyD: 'KeyD', // ctrlKey + KeyD on mac => keyDelete
  keyEnd: 'End',
  keyHome: 'Home',
  keyInsert: 'Insert',
  keyPageUp: 'PageUp',
  keyPageDown: 'PageDown',
  keyComma: 'Comma',
} as const
